var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraphsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 166.10001,
    width: 166.10001,
    viewBox: "0 0 166.1 166.10001",
    "data-name": "Capa 1",
    id: "Capa_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#c72e26;}.cls-2,.cls-4{fill:#fff;}.cls-3{fill:#737373;}.cls-4{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:0.25px;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124.31999,-39.75)",
    id: "Rankings"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#c72e26"
    },
    r: 83.050003,
    cy: 122.8,
    cx: 207.37,
    className: "cls-1",
    "data-name": "Elipse 5-2",
    id: "Elipse_5-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 190.56,157 h -19 v -19 h 19 z m 25.33,-28.51 h -19 V 157 h 19 z m 25.34,-12.67 h -19 V 157 h 19 z m 0,-34.84 -19,3.87 5.43,5.41 -21.66,21.32 -9.51,-9.51 -24.83,24.7 4.47,4.49 20.32,-20.26 9.47,9.48 26.23,-25.77 5.27,5.26 z",
    className: "cls-2",
    id: "chart-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraphsIcon);
export default __webpack_public_path__ + "static/media/circle-graphs-icon.5ca13406f2450852abc82877269563b4.svg";
export { ForwardRef as ReactComponent };